module.exports = __webpack_public_path__ + "img/radioklasik.643a28f4.jpg";